import * as React from 'react';

export const useDisableSave = () => {
  // @Note prevent saving using the save button
  // because the form is missing the vendor_id and other information
  React.useEffect(() => {
    const saveButton = document.getElementById('saveButton')! as HTMLButtonElement;
    saveButton.disabled = true;
    return () => {
      saveButton.disabled = false;
    };
  }, []);
};
